import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { readListDetailOpenMode, writeListDetailOpenMode } from '../utils/listDetailOpenMode';

/**
 * Same behavior as Job Requirements: choose whether row opens detail on a new page, in a dialog, or in a side drawer.
 *
 * @param {string} storageKey unique per list (e.g. "contacts")
 */
export default function useListDetailOpenMode(storageKey) {
  const navigate = useNavigate();
  const [mode, setModeState] = useState(() => readListDetailOpenMode(storageKey));
  const [popupId, setPopupId] = useState(null);
  const [sideId, setSideId] = useState(null);

  const persistMode = useCallback(
    (next) => {
      setModeState(next);
      writeListDetailOpenMode(storageKey, next);
    },
    [storageKey]
  );

  useEffect(() => {
    if (mode !== 'side') setSideId(null);
  }, [mode]);

  useEffect(() => {
    if (mode !== 'popup') setPopupId(null);
  }, [mode]);

  /**
   * @param {object} row
   * @param {(row: object) => string} pathFn full path e.g. (r) => `/contacts/${r.id}`
   */
  const openRow = useCallback(
    (row, pathFn) => {
      const path = pathFn(row);
      const id = row?.id;
      if (id == null) return;
      if (mode === 'page') {
        navigate(path);
      } else if (mode === 'popup') {
        setPopupId(id);
      } else {
        setSideId(id);
      }
    },
    [mode, navigate]
  );

  return {
    mode,
    persistMode,
    popupId,
    setPopupId,
    sideId,
    setSideId,
    openRow,
  };
}
